import React, { useState} from 'react'
import { Drawer, List, ListItem, IconButton, Link, Container, Grid, Divider } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import globalUseStyles from '../styleHooks';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../img/pantheon-logo-dark.svg'
import CloseIcon from '@material-ui/icons/Close';



const DrawerComponent = () => {
const [openDrawer, setOpenDrawer] = useState(false);
const globalClasses = globalUseStyles();

    return (
        <>
        <Drawer
            onClose={()=> setOpenDrawer(false)}
            open={openDrawer}
            anchor="right"
        >
        <Container >
        <Grid item xs={12} container style={{padding: '10px 0'}}>
        <Grid item xs={8} style={{display: 'flex'}}>
                <img style={{paddingTop:10, width:'70%'}}src={logo} alt="logo"/>
        </Grid>
        <Grid item xs={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
        <IconButton className={globalClasses.buttonFlex}>
                <CloseIcon style={{ color: `#555263` }} onClick={()=>setOpenDrawer(!openDrawer)}/>
        </IconButton>
 
        </Grid>    
        </Grid>
        </Container>
        <Divider/>  
            <List>
                <ListItem button>
                        <Link className={globalClasses.mobileNav}  to='/solutions' onClick={()=>setOpenDrawer(!openDrawer)} component={RouterLink} color="inherit" variant="body2">Our Services and Solutions</Link>
                </ListItem>
                <ListItem  button>
                        <Link className={globalClasses.mobileNav}  to='/work' onClick={()=>setOpenDrawer(!openDrawer)} component={RouterLink} color="inherit" variant="body2">Our Work</Link>
                </ListItem>
                <ListItem  button>
                        <Link className={globalClasses.mobileNav}  to='/government' onClick={()=>setOpenDrawer(!openDrawer)} component={RouterLink} color="inherit" variant="body2">Government Services</Link>
                </ListItem>
                <ListItem button>
                        <Link className={globalClasses.mobileNav} to='/who' onClick={()=>setOpenDrawer(!openDrawer)} component={RouterLink} color="inherit" variant="body2">Who We Are</Link>
                </ListItem>
                <ListItem button>
                        <Link className={globalClasses.mobileNav}  to='/careers' onClick={()=>setOpenDrawer(!openDrawer)} component={RouterLink} color="inherit" variant="body2">Careers</Link>
                </ListItem>
                <Divider style={{marginTop:10, marginBottom: 10}} />
                <ListItem button>
                        <Link className={globalClasses.mobileUtility}  to='/support' onClick={()=>setOpenDrawer(!openDrawer)} component={RouterLink} color="inherit"  variant="body2">Support</Link>
                </ListItem>
                <ListItem button>
                        <Link   className={globalClasses.mobileUtility} to='/contact' onClick={()=>setOpenDrawer(!openDrawer)} component={RouterLink} color="inherit" variant="body2">Contact Us</Link>
                </ListItem>                
            </List>
        </Drawer>
        <IconButton style={{marginLeft: 'auto', fontSize: 50,}} onClick={()=>setOpenDrawer(!openDrawer)}>
            <MenuIcon style={{color: '#ffffff', fontSize: 50}}/>
        </IconButton>
        </>
    )
}

export default DrawerComponent